/* eslint-disable max-len */
import * as React from 'react';

const Play = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.1761 3.33325C16.845 3.33325 13.5888 4.32102 10.8191 6.17166C8.04945 8.02229 5.89076 10.6527 4.61602 13.7302C3.34128 16.8077 3.00775 20.194 3.65761 23.4611C4.30746 26.7281 5.91152 29.7291 8.26693 32.0845C10.6223 34.4399 13.6233 36.044 16.8904 36.6938C20.1574 37.3437 23.5438 37.0102 26.6213 35.7354C29.6988 34.4607 32.3292 32.302 34.1798 29.5323C36.0304 26.7627 37.0182 23.5064 37.0182 20.1754C37.0182 17.9636 36.5826 15.7735 35.7362 13.7302C34.8898 11.6868 33.6492 9.83012 32.0853 8.26619C30.5213 6.70226 28.6647 5.46168 26.6213 4.61528C24.5779 3.76889 22.3878 3.33325 20.1761 3.33325ZM16.8904 25.7233V13.7405L26.1204 20.1754L16.8904 25.7233Z"
      fill="#7441C7"
    />
  </svg>
);
export default Play;
